export const generateDefaultEventName = ({ t }) =>
  t('PLANNING.SCHEDULER.UNTITLED_SLOT');
